import { render, staticRenderFns } from "./channelPacket.vue?vue&type=template&id=df663702&scoped=true"
import script from "./channelPacket.vue?vue&type=script&lang=js"
export * from "./channelPacket.vue?vue&type=script&lang=js"
import style0 from "./channelPacket.vue?vue&type=style&index=0&id=df663702&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df663702",
  null
  
)

export default component.exports